// extracted by mini-css-extract-plugin
export default {"percent":"ExportingLabel_percent__c+ebd"};